<template>
  <div class="item"
    @click.stop="setDetail">
    <div v-if="isIncludes('image')" class="img">
      <img :src="getItemThumb(item)" alt="">
      <button v-if="collectionIcon"
        type="button"
        class="btnCollection"
        @click.stop="deleteCollection(item.collectionItemId)">
        <img :src="collectionIcon.active" alt="" :style="{width: collectionIcon.size}">
      </button>
    </div>
    <div class="text">
      <div class="left">
        <div v-if="isIncludes('name')" class="name" :style="itemStyle.name">
          {{ item.collectionItemName[lang] }}
        </div>
        <div v-if="isIncludes('descTop')" class="descTop" :style="itemStyle.descTop">
          <pre>{{ item.attribute.descTop[lang] }}</pre>
        </div>
      </div>
      <div class="right">
        <div v-if="isIncludes('descBottom')" class="descBottom" :style="itemStyle.descBottom">
          <pre>{{ item.attribute.descBottom[lang] }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollectionItem',
  props: [
    'locale',
    'lang',
    'categoryId',
    'item',
    'collectionIcon',
    'itemDisplay'
  ],
  computed: {
    itemStyle () {
      const spacing = this.$store.getters['collection/getCommonItemStyle']
      return {
        ...spacing && spacing.name && {
          name: {
            letterSpacing: spacing.name
          }
        },
        ...spacing && spacing.descTop && {
          descTop: {
            letterSpacing: spacing.descTop
          }
        },
        ...spacing && spacing.descBottom && {
          descBottom: {
            letterSpacing: spacing.descBottom
          }
        }
      }
    }
  },
  methods: {
    isIncludes (el) {
      return this.itemDisplay && this.itemDisplay.includes(el)
    },
    getItemThumb (item) {
      const image = item && item.attribute && item.attribute.image
      const imageList = item && item.attribute && item.attribute.imageList
      return (imageList && imageList[0]) || image
    },
    async deleteCollection (collectionItemId) {
      this.$emit('deleteItem', collectionItemId)
    },
    setDetail () {
      const item = this.item
      if (item.attribute.detailActive) {
        const detailType = item.attribute.detailType
        if (detailType === 'embed') {
          this.$store.commit('collection/setDetailVideo', item.collectionItemId)
        } else {
          this.$store.commit('collection/setDetailGallery', item.collectionItemId)
        }
      }
    },
  }
}
</script>